import { useTranslation } from '../../lib/i18n';
import { getPostSchema } from '../../lib/schema-org';
import CmsDetail from '../cms/detail';
import { Related } from '../common/related';

const PostDetail = ({ post, preview, related }) => {
  const { t } = useTranslation();
  return (
    <CmsDetail
      content={post}
      preview={preview}
      // allowWishlist={true}
      // Navigation={<PostNavigation />}
      // Meta={<PostMeta post={post} className='mb-8' />}
      leftAlign={true}
      ldJson={getPostSchema(post)}
    >
      <Related
        className='mt-12'
        title={t('otherArticles')}
        btnLink={`/blog`}
        btnText={t('blogTitle')}
        items={related}
      />
    </CmsDetail>
  );
};

export default PostDetail;
